import React, { useEffect, useState } from 'react';
import { StyledRenameChatModal } from './RenameChatModal.style';
import { useForm } from '../../Form';
import Form from '../../Form/Form';
import Field from '../../Field';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Button from '../../Button';
import sessionsService from '../../../services/sessionsServices';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';

const RenameChatModal = ({ onClose, data }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [textString, setTextString] = useState(data?.title);
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async e => {
      return await sessionsService?.updateSession({
        platform_id: 'feedalabs',
        session_id: data?.id,
        user_id: '123',
        agent_id: 'ferdy',
        title: e?.title,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  useEffect(() => {
    if (data?.title) {
      const htmlString = textString;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      setTextString(tempDiv.innerText.trim());

      form.setFieldsValue({
        title: textString,
      });
    }
  }, [data?.title, textString]);

  return (
    <StyledRenameChatModal form={form} onSubmit={e => handleSubmit.mutate(e)}>
      <Form.Item
        type="text"
        name="title"
        placeholder="Enter chat title"
        label="Chat Title"
        rules={[
          {
            required: true,
            message: 'Title is required',
          },
        ]}>
        <Field />
      </Form.Item>
      <div className="btn-holder">
        <Button width="102px" type="button" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="108px" loader={handleSubmit?.isPending}>
          Update
        </Button>
      </div>
    </StyledRenameChatModal>
  );
};

export default RenameChatModal;
